/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import NoDataError from './NoDataError';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    backgroundColor: '#fff',
    borderRadius: '6px',
    padding: '2rem 1rem 1rem 1rem',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    margin: '20px auto',
    width: '601px',
    height: '646px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '90vw !important',
    },
    [theme.breakpoints.up('sm')]: {
      width: '79vw !important',
    },
    [theme.breakpoints.up('md')]: {
      width: '39vw !important',
    },
  },
  // cardHeader: {
  //   fontSize: '3rem !important',
  //   fontFamily: 'Playfair Display, sans-serif!important',
  //   color: 'black',
  //   fontWeight: 'bold',
  // },
  // cardSubHeader: {
  //   marginTop: '1rem',
  //   fontSize: '0.875rem !important',
  //   fontFamily: 'Roboto Mono, sans-serif!important',
  //   color: '#B3261D'
  // },
  cardContent: {
    backgroundColor: '#F5E2DC',
    padding: '1rem',
    margin: '20px auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '400px',
    borderRadius: '0.375rem',
    minHeight: '402px',
    [theme.breakpoints.down('sm')]: {
      width: '260px',
    },
    '& p': {
      color: '#B3261D',
      fontSize: '1.7rem !important',
      fontWeight: '600',
      lineHeight: '3rem',
      fontFamily: 'Playfair Display',
      maxHeight: '350px !important',
      paddingRight: '1rem',
      overflowY: 'auto',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.1rem !important',
      },
    }
  },
  actionButtons: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    padding: 20,
  },
  shuffleButton: {
    backgroundColor: '#ededed !important',
    color: 'black !important',
    borderColor: 'transparent !important',
    textTransform: 'uppercase',
    width: '89% !important',
    borderRadius: '6px',
    height: '52px',
    position: 'relative',
    bottom: '0',
    '& span':{
      fontFamily: 'Raleway, sans-serif !important',
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '28px',
      letterSpacing: '1px',
      '& svg': {
        fontSize: '1.1rem',
        marginLeft: '0.2rem'
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
  },
}));

export default function PlayBookList({ items, cardHeader, cardSubHeader, actionLabels }) {
  const classes = useStyles();

  if (items?.length === 0) {
    return <NoDataError />
  }

  const [itemIdx, setItemIdx] = useState(0);

  const shuffle = () => {
    let newIdx = itemIdx;
    while (true) {
      newIdx = Math.floor(Math.random() * items?.length);
      if (newIdx !== itemIdx) {
        break;
      }
    }
    setItemIdx(newIdx);
  }
  return (
    <div className={classes.cardContainer}>
      {cardHeader && <div className='cardHeader'> {cardHeader} </div>}
      {cardSubHeader && <div className='cardSubHeader'> {cardSubHeader}</div>}
      <div className={classes.cardContent}>
        <p>{items?.[itemIdx]}</p>
      </div>
      <Button className={classes.shuffleButton} onClick={() => { shuffle() }}>
        {actionLabels[0]} <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6851 6.67828C15.5268 4.67869 13.3619 3.33337 10.8823 3.33337C8.07094 3.33337 5.66405 5.06283 4.67028 7.51451M14.6505 7.51451H18V4.1696M5.14823 13.3681C6.30651 15.3677 8.47144 16.713 10.951 16.713C13.7624 16.713 16.1693 14.9835 17.1631 12.5319M7.18283 12.5319H3.83333V15.8768" stroke="#333333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </Button>
    </div>

  );
}
